<template>
  <mds-layout-grid :class="sectionClasses">
    <mds-row>
      <mds-col :class="headerClasses" :cols="12">
        <div :class="titleClasses">
          <slot name="title"></slot>
        </div>
        <mds-button-container :class="actionCtClasses" right-aligned>
          <slot name="action"></slot>
        </mds-button-container>
      </mds-col>
    </mds-row>
    <hr v-if="showDivider" />
    <mds-row>
      <mds-col>
        <slot></slot>
      </mds-col>
    </mds-row>
  </mds-layout-grid>
</template>
<script>
import { MdsLayoutGrid, MdsRow, MdsCol } from '@mds/layout-grid';
import { MdsButtonContainer } from '@mds/button';

export default {
  name: 'fee-schedule-item-layout',
  components: {
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsButtonContainer,
  },
  props: {
    sectionClasses: Array,
    headerClasses: Array,
    titleClasses: Array,
    actionCtClasses: Array,
    showDivider: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
